/**
 * Мелочи, общие для экранов курьера.
 *
 * Вынесены, чтобы четыре экрана не завели четыре слегка разных копии одних и
 * тех же стилей — расхождение в таких местах замечают позже всего.
 */
import type { CSSProperties } from 'react';
import type { OrderStatus } from '@arbuz/shared';

/**
 * Цвет статуса. Рядом с ним всегда идёт подпись: цвет не может быть
 * единственным носителем смысла — см. скилл `design-system`.
 */
export function statusColor(status: OrderStatus): string {
  if (status === 'delivered') return 'var(--c-success)';
  if (status === 'cancelled' || status === 'failed') return 'var(--c-danger)';
  return 'var(--c-text)';
}

export const secondaryButton: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: 'var(--tap-min)',
  padding: 'var(--s-3) var(--s-4)',
  borderRadius: 'var(--r-lg)',
  border: '1px solid var(--c-border-input)',
  background: 'var(--c-surface)',
  color: 'var(--c-primary-text)',
  font: 'var(--fw-medium) var(--fs-body)/var(--lh-body) var(--font)',
  cursor: 'pointer',
  textDecoration: 'none',
};

export const dangerButton: CSSProperties = {
  ...secondaryButton,
  color: 'var(--c-danger)',
  borderColor: 'var(--c-danger)',
};

export const inputStyle: CSSProperties = {
  width: '100%',
  minHeight: 'var(--tap-min)',
  padding: 'var(--s-2) var(--s-3)',
  borderRadius: 'var(--r-md)',
  border: '1px solid var(--c-border-input)',
  background: 'var(--c-surface)',
  color: 'var(--c-text)',
  font: 'var(--fw-regular) var(--fs-body)/var(--lh-body) var(--font)',
};

export const labelStyle: CSSProperties = {
  display: 'block',
  marginBottom: 'var(--s-2)',
  fontSize: 'var(--fs-sm)',
  color: 'var(--c-text-secondary)',
};

/** Строка «подпись — значение» в карточке заказа. */
export const rowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 'var(--s-3)',
  margin: 'var(--s-2) 0 0',
};
